import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"

import ciao from "images/villagrecoimmagini/generale/giardinoGenerali/1.webp"
import ciao3 from "images/villagrecoimmagini/generale/giardinoGenerali/3.jpg"
import ciao5 from "images/villagrecoimmagini/generale/giardinoGenerali/5.jpg"
import ciao6 from "images/villagrecoimmagini/generale/giardinoGenerali/6.jpg"
import ciao8 from "images/villagrecoimmagini/generale/giardinoGenerali/8.jpg"
import ciao9 from "images/villagrecoimmagini/generale/giardinoGenerali/9.jpg"
import ciao10 from "images/villagrecoimmagini/generale/giardinoGenerali/10.webp"
import ciao11 from "images/villagrecoimmagini/generale/giardinoGenerali/11.jpg"
import ciao12 from "images/villagrecoimmagini/generale/giardinoGenerali/12.jpg"
import ciao13 from "images/villagrecoimmagini/generale/giardinoGenerali/13.jpg"
import ciao14 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/8.webp"
import ciao15 from "images/villagrecoimmagini/3-Bouganville/esterno/1.jpg"
import ciao16 from "images/villagrecoimmagini/3-Bouganville/esterno/2.jpg"

const immaginiPaesaggi = [ciao5, ciao10, ciao15, ciao16, ciao9, ciao, ciao3, ciao8, ciao11, ciao12, ciao13, ciao14]

const SezioneCaroselloPaesaggi = () => {
  return (
    <div className="nc-SezioneCaroselloPaesaggi relative m-5">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-semibold">Esplora il Paesaggio</h2>
        <p className="mt-2 text-neutral-500">Scopri la bellezza che circonda Villa Greco</p>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop
        className="rounded-2xl overflow-hidden"
      >
        {immaginiPaesaggi.map((src, index) => (
          <SwiperSlide key={index}>
            <img
              src={src}
              alt={`Vista Paesaggio ${index + 1}`}
              className="w-full h-[40vh] sm:h-[50vh] md:h-[50vh] lg:h-[80vh] object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default SezioneCaroselloPaesaggi
